import { SettingsServiceTypes as Types } from 'common/settingsService/types';
import { SettingsGroupItems } from 'common/settingsService/impl/models/SettingsGroupItems';

export class SettingsGroup<
  GROUP_KEY extends string = string,
  FLAGS_MODEL extends Types.GroupItemsModel = Types.GroupItemsModel
> {
  name: GROUP_KEY;

  private readonly items: SettingsGroupItems<FLAGS_MODEL>;

  constructor(name: GROUP_KEY, items: SettingsGroupItems<FLAGS_MODEL>) {
    this.name = name;
    this.items = items;
  }

  static fromGroupModel<INPUT_GROUP_MODEL extends Types.GroupModel>(groupModel: INPUT_GROUP_MODEL) {
    return new SettingsGroup(
      groupModel.name as INPUT_GROUP_MODEL['name'],
      new SettingsGroupItems(groupModel.items as NonNullable<INPUT_GROUP_MODEL['items']>)
    );
  }

  static fromItemsModel<INPUT_GROUP_KEY extends string, INPUT_ITEMS_MODEL extends Types.GroupItemsModel>(
    groupKey: INPUT_GROUP_KEY,
    flagsModel: INPUT_ITEMS_MODEL
  ): SettingsGroup<INPUT_GROUP_KEY, INPUT_ITEMS_MODEL> {
    return new SettingsGroup(groupKey, SettingsGroupItems.fromItemsModel(flagsModel));
  }

  merge<INPUT_GROUP extends SettingsGroup>(
    group: INPUT_GROUP
  ): SettingsGroup<GROUP_KEY, FLAGS_MODEL & INPUT_GROUP['model']['items']> {
    return SettingsGroup.fromItemsModel(this.name, {
      ...this.items.model,
      ...group.model.items
    });
  }

  get model(): Types.GroupModel<GROUP_KEY, FLAGS_MODEL> {
    return {
      name: this.name,
      items: this.items.model
    };
  }
}
